module.exports = __webpack_public_path__ + "Assets/ef7e8467-66c5-4521-afc4-777f6cf72ec4.woff";